import React from 'react';
import {Container} from 'react-bootstrap';
import {Link} from 'react-router-dom';

export const Verify2Home = () => {
    return (
        <div className="bloc l-bloc" id="bloc-0">
            <Container className="block-lg">
                <div className="row">
                    <div className="col">
                        <ul className="list-unstyled list-sp-md">

                            <li>======== 기본메뉴 ======</li>
                            <li><Link to="verification2/config" className="a-btn a-block">기본환경설정</Link></li>
                            <li><Link to="verification2/t1" className="a-btn a-block">검증 1</Link></li>
                            <li><Link to="verification2/t2" className="a-btn a-block">검증 2</Link></li>
                            <li><Link to="verification2/t3" className="a-btn a-block">검증 3</Link></li>
                            <li><Link to="verification2/t4" className="a-btn a-block">검증 4</Link></li>
                            <li><Link to="verification2/t5" className="a-btn a-block">검증 5</Link></li>

                        </ul>
                    </div>
                </div>
            </Container>
        </div>
    );
};

